import { useState } from "react";
import { ConfirmCloseDialog } from "./ConfirmCloseDialog";

type Options = {
  isDirty: boolean;
  onClose: () => void;
  title?: string;
  text?: string;
};

/**
 * Asks for confirmation before closing when there is unsaved content.
 * Call `requestClose` from every close trigger (X, Close button, modal `onClose`) and render `confirmCloseDialog`.
 */
export const useConfirmClose = ({ isDirty, onClose, title, text }: Options) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const requestClose = () => {
    if (isDirty) {
      setIsConfirmOpen(true);
      return;
    }
    onClose();
  };

  const confirmCloseDialog = (
    <ConfirmCloseDialog
      isOpen={isConfirmOpen}
      title={title}
      text={text}
      onCancel={() => setIsConfirmOpen(false)}
      onConfirm={() => {
        setIsConfirmOpen(false);
        onClose();
      }}
    />
  );

  return { requestClose, confirmCloseDialog };
};
